module.exports = __webpack_public_path__ + "static/media/kerala.d8fca879.jpg";